import { ContactPaymentOrderItemInterface } from 'modules/contacts/contact-page/types/contact-payments-interface'
import { getContactPaymentUrl } from 'modules/contacts/contact-page/utils/get-contact-payment-url'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getProductPriceAmount } from 'modules/payment/transactions/utils/product-transactions-utils'
import useUser from 'shared/hooks/use-user'

interface ContactPaymentsPaymentTooltipProps {
  orderItem: ContactPaymentOrderItemInterface
}

const ContactPaymentTooltip = ({ orderItem }: ContactPaymentsPaymentTooltipProps) => {
  const { t } = useLocoTranslation()
  const { user } = useUser()

  const pricePlan = orderItem.pricePlan
  const productOrderItem = orderItem.productOrderItem
  const quantity = productOrderItem?.quantity ?? 1

  return (
    <PricePlanTooltip
      pricePlan={pricePlan}
      productPriceAmount={getProductPriceAmount(quantity, productOrderItem, user?.dashboardLocale)}
      customRow={
        productOrderItem?.productVariant && (
          <p className="text-start">
            <span className="text-darkblue font-bold">
              {t('dashboard.price_plan.products_variant.title')}:{' '}
            </span>
            {productOrderItem.productVariant.productOptionValues?.map(e => e.value).join(' / ')}
          </p>
        )
      }
    >
      <div className={'truncate'}>
        {orderItem.offer && orderItem.offer.removedAt === null && orderItem.offer.funnelStep ? (
          <LinkWithoutPrefetch
            rel="noreferrer"
            className="primary-link"
            href={getContactPaymentUrl(
              orderItem.offer.funnelStep.funnel.id,
              orderItem.offer.funnelStep.id,
            )}
          >
            {pricePlan ? pricePlan.innerName : productOrderItem && productOrderItem.product.name}
          </LinkWithoutPrefetch>
        ) : pricePlan ? (
          pricePlan.innerName
        ) : (
          productOrderItem && productOrderItem.product.name
        )}
      </div>
    </PricePlanTooltip>
  )
}

export default ContactPaymentTooltip
